import FJStepHeaderContainer from './FJStepHeader/FJStepHeaderContainer';
import styles from './index.module.less';
import { useDispatch, useSelector } from 'react-redux';
import FJActionTextToVideo from '../../redux/action/FJActionTextToVideo';
import { useCallback } from 'react';
import FJNavBar from '../../common/components/FJNavBar/FJNavBar';
import { TEXT_TO_VIDEO_TAB_LIST } from '../../config/dataConfig/FJTextToVideoDataConfig';
import FJAppConstant from '../../constants/FJAppConstant';
import FJTextToFullVideoContainer from './FJTextToFullVideo/FJTextToFullVideoContainer';
import FJBlogUrlToVideoContainer from './FJBlogUrlToVideo/FJBlogUrlToVideoContainer';
import FJProductToVideoContainer from './FJProductToVideo/FJProductToVideoContainer';
import FJPptToVideoContainer from './FJPptToVideo/FJPptToVideoContainer';
import { useEffect } from 'react';
import FJConfig from '../../config/FJConfig';
import useLocalStore from '../../hooks/useLocalStore';
const FJTextToVideo = () => {
    const dispatch = useDispatch();
    useLocalStore();
    useEffect(() => {
        !window.isEditPage && dispatch(FJActionTextToVideo.onTabChangeAction(FJConfig.currentMenuName));
        dispatch(FJActionTextToVideo.getAndSetLanguageAndVoiceListAction());
    }, [dispatch]);
    const selectTab = useSelector(state => state.textToVideo.selectTab);
    const onChangeTab = useCallback(
        tab => {
            dispatch(FJActionTextToVideo.onTabChangeAction(tab));
        },
        [dispatch],
    );

    return (
        <div className={styles.container}>
            <div className={styles.left}>
                <FJNavBar selectTab={selectTab} onChangeTab={onChangeTab} tabList={TEXT_TO_VIDEO_TAB_LIST} />
            </div>
            <div className={styles.right}>
                <FJStepHeaderContainer className={styles.step_header} />
                {selectTab === FJAppConstant.TEXT_TO_FULL_VIDEO && <FJTextToFullVideoContainer />}
                {selectTab === FJAppConstant.BLOG_URL_TO_VIDEO && <FJBlogUrlToVideoContainer />}
                {selectTab === FJAppConstant.PRODUCT_URL_TO_VIDEO && <FJProductToVideoContainer />}
                {selectTab === FJAppConstant.PPT_TO_VIDEO && <FJPptToVideoContainer />}
            </div>
        </div>
    );
};

export default FJTextToVideo;
